<template>
  <BaseTemplate :currentUser="currentUser">
    <div class="privacy-protection">
      <Title jpn="隱私權政策" />
      <div class="scroll-container">
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">Xero Place Co., Ltd.（以下簡稱「本公司」）要求使用者提供最低限度的個人訊息，以便他們能夠安心地使用網站。</span>
            <span class="text">此外，我們極為謹慎地保護提供給我們的個人資訊。</span>
            <br>
            <span class="text">本公司的個人資訊保護方針如下。</span>
            <span class="text">(1)公司將僅使用會員註冊的個人、組織和法人的資訊來開發和提供尖端的功能和服務，並將高度重視會員個人資訊的保護。</span>
            <span class="text">(2) 本隱私權政策僅適用於本公司提供的服務。</span>
            <span class="text">(3) 除本條款規定外，該資訊不會用於任何其他目的。</span>
            <span class="text">(4) 除本條款另有規定外，我們不會向第三方揭露您的資訊。</span>
            <span class="text">（5）我們將定期採用本條款規定的其他方式進行適當的管理。</span>
            <span class="text">(6) 本公司可能會在未經使用者許可的情況下變更隱私權政策。</span>
            <span class="text">當本公司對所取得的個人資訊的內容、使用方法、公開內容等進行變更時，我們會透過在本公司網站上發佈公告的方式通知您，並反映在本隱私權政策中，以便使用者知曉該內容。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">第一節 我們的隱私權政策的適用範圍</span>
            <span class="text">(1) 會員使用我們的服務時，適用我們的隱私權政策。</span>
            <span class="text">(2)會員使用我們的服務時所收集的個人資料將依照本公司的個人資訊保護政策進行管理。</span>
            <span class="text">(3) 我們的個人資訊保護保單僅適用於本公司直接提供的服務，不適用於其他組織或本公司提供的服務。</span>
            <span class="text">(4)使用我們的服務的風險由使用者自行承擔。</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">第 2 節. 我們個人資訊的收集與使用</span>
            <span class="text">(1) 為了開發並向我們的會員提供尖端的功能和服務，我們需要用戶提供一些個人資訊。</span>
            <span class="text">(2) 使用者有責任管理其註冊郵箱地址和密碼。</span>
            <span class="text">1. 定期更改密碼，不建議使用姓名、出生日期、電話號碼等容易被他人猜到的內容。</span>
            <span class="text">2. 請不要透露、出借或轉讓您的個人訊息，即使是向熟人或朋友透露。</span>
            <span class="text">(3) 所收集的個人資訊將僅在提供我們的服務所需的範圍內使用，除以下情況外，不會向任何第三方提供。</span>
            <span class="text">1. 當信用卡公司進行調查以調查信用卡詐欺行為時。</span>
            <span class="text">2. 向會員發送廣告郵件等時。</span>
            <span class="text">3. 在實現使用者指定的使用目的所需的範圍內，將個人資訊委託給與我們簽訂了個人資訊保密協議的分包商處理時。</span>
            <span class="text">4. 當認為有必要保護其他會員、第三方或公司的權利或財產時，會員在公司的行為違反公司的政策、公告或公司的使用條款。</span>
            <span class="text">5. 依法院或行政機關的命令等其他法律規定要求披露個人資訊時，或出於刑事調查、消除或防止對第三方的侵權行為等需要時。</span>
            <span class="text">(4) 會員應事先同意本公司依上述規定的方式使用個人資訊，且不得提出任何異議。</span>
            <span class="text">(5) 此外，在以下情況下，我們可能會與我們的業務合作夥伴分享會員的個人資訊：</span>
            <span class="text">1. 有業務原因時，例如為會員提供特殊服務。在此情況下，我們會在提供資訊前徵求會員的同意，未經會員同意我們不會提供資訊。</span>
            <span class="text">2. 建立統計資料、進行市場調查或進行資料分析時。在這種情況下，我們只會提供經過處理的信息，以便無法識別特定個人。</span>
          </div>
        </ShadowBoxTitleDescription>
      </div>
    </div>
  </BaseTemplate>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import ShadowBoxTitleDescription from '@/components/molecules/ShadowBoxTitleDescription.vue';
import Title from '@/components/molecules/Title02.vue';
import t from '@/plugins/i18n';

export default {
  name: 'TermsOfService',
  mixins: [t],

  components: {
    BaseTemplate,
    ShadowBoxTitleDescription,
    Title,
  },

  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
    }),
  },

  created() {
    this.$store.dispatch('user/setCurrentUser', { token: 'yugi' });
  },
};
</script>

<style lang="scss" scoped>
.privacy-protection{
  width: 100%;
  max-width: 1200px;
  min-height: 100%;
  padding: 30px 20px 0;
  margin: 0 auto;
  .privacy-protection-title{
    display: flex;
    justify-content: center;
    .text{
      height: 35px;
      font-family: $notoSerif;
      font-size: 24px;
      font-weight: 700;
    }
  }
  .scroll-container{
    width: 100%;
    margin-top: 30px;
    padding-bottom: 50px;
    max-width: 1000px;
    margin-left: auto;
    margin-right: auto;
    .shadow-box-title-description{
      width: 100%;
      .text-container{
        display: flex;
        flex-direction: column;
        padding: 5px 5px 0 5px;
        .text{
          font-family: $notoSans;
          font-size: 13px;
          line-height: 1.5;
          letter-spacing: 0.03em;
          a {
            color: $white!important;
          }
          &.margin-top{
            margin-top: 10px;
          }
          &.one-line-space-top{
            margin-top: 1em;
          }
          &.indent{
            padding-left: 2.6em;
            text-indent: -1.6em;
          }
        }
      }
      & + .shadow-box-title-description{
        margin-top: 40px;
      }
    }
  }
}
</style>
